import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/listing/actionTypes';

import { closeAppointmentsDialog } from './utils';

export default function* listenCloseAppointmentsDialog() {
  yield takeEvery(actionTypes.CLOSE_APPOINTMENTS_DIALOG, closeAppointmentsDialog);
}
